import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { EuiPopoverComponent } from './eui-popover.component';

@NgModule({
    imports: [
        CommonModule,
        OverlayModule,
    ],
    declarations: [
        EuiPopoverComponent,
    ],
    exports: [
        EuiPopoverComponent,
    ],
})
export class EuiPopoverModule { }
